import React, { useEffect, useState } from "react";
import Select from "react-select";

import { useOrders } from "../OrdersContext";
import { updateProduct } from "services/api";

export const ChangeWarehouse = ({ row, warehouses }) => {
  const { setLoading, setProducts } = useOrders();
  const [warehouse, setWarehouse] = useState({
    label: row.warehouse?.name,
    value: row.warehouse?.id,
  });

  const warehouseHandler = (data) => {
    setWarehouse(data);
    setLoading(true);
    updateProduct({
      ...row,
      provider: row.provider?.id,
      warehouse: data.value,
    })
      .then((res) => setProducts(res))
      .finally(() => setLoading(false));
  };

  return (
    <Select
      name="warehouse"
      placeholder="Выберите склад"
      className="react-select-container"
      classNamePrefix="react-select"
      options={warehouses.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      })}
      value={warehouse}
      onChange={warehouseHandler}
    />
  );
};
